'use client';

import { useTranslations } from 'next-intl';
import { AgentLineVideo } from '@/app/components/icons/AgentLineVideo';
import { BaseLinePlus } from '@/app/components/icons/BaseLinePlus';
import { ProductLineLoadingPic } from '@/app/components/icons/ProductLineLoadingPic';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { Button } from '@/app/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/app/components/ui/dropdown-menu';

interface FileUploadButtonProps {
  onSelectImages: () => void;
  onSelectVideo: () => void;
  disabledUploadTooltip: { image?: string; video?: string };
}

/**
 * 文件上传按钮组件
 * 提供图片和视频上传的下拉菜单
 */
export function FileUploadButton({ disabledUploadTooltip, onSelectImages, onSelectVideo }: FileUploadButtonProps) {
  const t = useTranslations();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="flex h-8 min-w-12 items-center justify-center rounded-full bg-system-white04 hover:border-system-white64 hover:bg-system-white24"
        >
          <BaseLinePlus className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        className="data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 min-w-[140px] rounded-12 border border-system-white08 bg-[rgba(34,37,42,0.48)] p-1 backdrop-blur-[30px] data-[state=closed]:animate-out data-[state=open]:animate-in"
        sideOffset={8}
        side="top"
      >
        <CustomTooltip content={disabledUploadTooltip.image} side="right">
          <DropdownMenuItem
            className="flex h-10 items-center gap-2"
            onSelect={onSelectImages}
            disabled={!!disabledUploadTooltip.image}
          >
            <ProductLineLoadingPic className="size-4" />
            {t('agentProject.chatDialog.input.type.image')}
          </DropdownMenuItem>
        </CustomTooltip>

        <CustomTooltip content={disabledUploadTooltip.video} side="right">
          <DropdownMenuItem
            className="flex h-10 items-center gap-2"
            onSelect={onSelectVideo}
            disabled={!!disabledUploadTooltip.video}
          >
            <AgentLineVideo className="size-4" />
            {t('agentProject.chatDialog.input.type.video')}
          </DropdownMenuItem>
        </CustomTooltip>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
